import { Typography } from '@capsule/consumer-design-system';

import InlineSVG from 'svg-inline-react';

import Marker from 'public/marker-dark.svg';
import { Skeleton } from 'src/app/components/Elements/Skeleton';

import { ListContainer, ListItem, ListSubText, ListTextContainer, PlaceIconContainer } from './styles';

export const SearchResultsView = ({ isFetchingNearby, selectItem, nearbyPlaces, displayProps, showSearchResults }) => {
  return (
    <>
      <ListContainer toggleShow={showSearchResults} isFullScreen={displayProps.isFullScreen}>
        {isFetchingNearby && showSearchResults ? (
          <Skeleton />
        ) : (
          nearbyPlaces?.map(item => {
            return (
              <ListItem
                type="button"
                key={`list-item-${item.place_id}`}
                onClick={() => {
                  selectItem(item);
                }}
              >
                <PlaceIconContainer aria-hidden>
                  <InlineSVG src={Marker} />
                </PlaceIconContainer>
                <ListTextContainer>
                  <Typography variant="body">{item.name}</Typography>
                  <ListSubText>
                    <Typography variant="small">{item.formatted_address}</Typography>
                  </ListSubText>
                </ListTextContainer>
              </ListItem>
            );
          })
        )}
      </ListContainer>
    </>
  );
};
